document.addEventListener('DOMContentLoaded', () => {

  const nav = document.querySelector('.problem-nav');
  if (!nav) return;

  const links = nav.querySelectorAll('a');
  const sections = document.querySelectorAll('section[id^="problem-"]');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = entry.target.id;
          links.forEach((link) => {
            link.classList.remove('problem-nav__link--active');
            if (link.getAttribute('href') === `#${id}`) {
              link.classList.add('problem-nav__link--active');
              link.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
          });
        }
      });
    },
    {
      rootMargin: '-50% 0px -50% 0px'
    }
  );

  sections.forEach((section) => {
    observer.observe(section);
  });
});
